import { render, staticRenderFns } from "./NewsProfile.vue?vue&type=template&id=59f8fcb4&scoped=true"
import script from "./NewsProfile.vue?vue&type=script&lang=js"
export * from "./NewsProfile.vue?vue&type=script&lang=js"
import style0 from "./NewsProfile.vue?vue&type=style&index=0&id=59f8fcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f8fcb4",
  null
  
)

export default component.exports